/**
 * GTGT homr
 */

export interface HomrGTGTContent {
  Subhead: string;
  altText: string;
  foregroundColor: string;
  headline: string;
  image: string;
  link: string;
  linkTitle: string;
}
